import {Button, Checkbox, CircularProgress, FormControlLabel, Grid, TextField, Typography} from '@material-ui/core';
import React, {useRef, useState} from 'react';
import {useDispatch} from 'react-redux';

import './../OwnerInfo.sass';
import './../WorkFlow.sass';

import {getAgentName} from 'ApplicationEntry/ducks/agentInformation';
import {matchAgentNumber} from 'ApplicationEntry/models/AgentNumber';
import {InvalidApplication, ValidApplication} from 'ApplicationEntry/models/Application';

import * as AR from 'ApplicationEntry/ducks/agentInformation';
import Alert from 'Shared/components/Alert';

import * as ErrorMessages from '../ErrorMessages';

type AgentDataProps = {
  agentIndex: number;
  editAgent: boolean;
  application: InvalidApplication | ValidApplication;
  agentListLength: number;
  totalPercent: number;
  signedValue: boolean;
  checkDuplicateAgent: boolean;
};

const getPercentErrorMessage = (percent: number) =>
  percent === 0 ? ErrorMessages.REQUIRED_MESSAGE : ErrorMessages.INVALID_PERCENTAGE;

const AgentData = (props: AgentDataProps) => {
  const {application, totalPercent, signedValue, checkDuplicateAgent} = props;

  const [percentBlurred, setBlurPercent] = useState(false);
  const [agentNameBlurred, setBlurAgentName] = useState(false);

  const showPercentError = percentBlurred && totalPercent > 100;

  const showDuplicateAgentError = agentNameBlurred && checkDuplicateAgent;

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const dispatch = useDispatch();

  const textInput = useRef<HTMLLabelElement | null>(null);

  const enableSigned = () => {
    if (props.editAgent) {
      if (!application.agentList.agentList.some(item => item.signed === true)) {
        return false;
      } else if (application.agentInformation.signed) {
        return false;
      } else {
        return true;
      }
    } else {
      return signedValue;
    }
  };

  return (
    <>
      <Grid className="contingent-beneficiary-section__contingent-beneficiary-view">
        <div className="contingent-beneficiary-section__contingent-beneficiary-view__sub-title-container">
          <Typography
            variant="subtitle1"
            className="contingent-beneficiary-section__contingent-beneficiary-view__sub-title-container-title"
          >
            Agent {props.editAgent ? props.agentIndex + 1 : props.agentListLength + 1}
          </Typography>
        </div>
        <form noValidate autoComplete="off" className="owner-info-section" style={{padding: '1em', margin: '0.5em'}}>
          <div className="owner-info-section__row">
            <Grid container spacing={4}>
              {matchAgentNumber({
                Loading: () => (
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Agent Number"
                      variant="filled"
                      placeholder="Agent Number"
                      className="owner-info-section__text-field"
                      value={''}
                      InputProps={{
                        endAdornment: <CircularProgress className="case-details-section__loading-policy-number-icon" />,
                      }}
                      inputProps={{maxLength: 5}}
                    />
                  </Grid>
                ),
                Loaded: pn => (
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Agent Number"
                      variant="outlined"
                      placeholder="Agent Number"
                      className="owner-info-section__text-field"
                      value={pn}
                      inputProps={{maxLength: 5}}
                      onChange={e => {
                        textInput.current?.focus();
                        dispatch(AR.updateUserAgentNumber(e.target.value as string));
                      }}
                    />
                  </Grid>
                ),
                Unassigned: () => (
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Agent Number"
                      variant="filled"
                      placeholder="Agent Number"
                      className="owner-info-section__text-field"
                      value={''}
                      onChange={e => {
                        textInput.current?.focus();
                        dispatch(AR.updateUserAgentNumber(e.target.value as string));
                      }}
                      inputProps={{maxLength: 5}}
                    />
                  </Grid>
                ),
                UserAssignedAgentNumber: pn => (
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Agent Number"
                      variant="outlined"
                      placeholder="Enter Agent Number"
                      className="owner-info-section__text-field"
                      value={pn}
                      margin="normal"
                      fullWidth
                      onChange={e => dispatch(AR.updateUserAgentNumber(e.target.value as string))}
                      id="user-assigned-agent-data-agent-number"
                      inputProps={{maxLength: 5}}
                      error={showDuplicateAgentError}
                      helperText={showDuplicateAgentError ? ErrorMessages.DUPLICATE_AGENT : ''}
                    />
                  </Grid>
                ),
                Error: () => (
                  <Grid item xs={12}>
                    <Alert
                      className="billing-agent-section__policy-number-error-label"
                      message="An Error Ocurred While Getting Agent Number."
                    />
                  </Grid>
                ),
                AgentNumberError: pn => (
                  <Grid item xs={12} md={3}>
                    <TextField
                      error
                      id="outlined-error-helper-text"
                      label="Agent Number"
                      defaultValue={pn}
                      helperText="Not a Valid Agent Number"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      value={pn}
                      onChange={e => dispatch(AR.updateUserAgentNumber(e.target.value as string))}
                      className="owner-info-section__text-field"
                      placeholder="Enter Agent Number"
                      inputProps={{maxLength: 5}}
                    />
                  </Grid>
                ),
              })(application.agentInformation.agentNumber)}
              <Grid item xs={12} md={3}>
                <TextField
                  id="agent-name"
                  label="Agent Name"
                  variant="filled"
                  placeholder="Agent Name"
                  inputProps={{readOnly: true}}
                  margin="normal"
                  fullWidth
                  className="owner-info-section__text-field"
                  value={application.agentInformation.agentName.value}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="percent"
                  label="Percent"
                  variant="outlined"
                  placeholder="Enter Percent"
                  margin="normal"
                  fullWidth
                  className="owner-info-section__text-field"
                  type="number"
                  error={showPercentError}
                  helperText={showPercentError ? getPercentErrorMessage(application.agentInformation.percent) : ''}
                  onBlur={() => setBlurPercent(true)}
                  value={application.agentInformation.percent}
                  onChange={e => dispatch(AR.updatePercent(parseInt(e.target.value === '' ? '0' : e.target.value, 10)))}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  className="owner-info-section__text-field"
                  control={
                    <Checkbox
                      checked={application.agentInformation.signed || false}
                      onChange={e => dispatch(AR.updateSigned(e.target.checked))}
                      name="checkedSigned"
                      color="secondary"
                      disabled={enableSigned()}
                    />
                  }
                  label={<Typography>Signed</Typography>}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  className="case-details__assign-policy-number-button"
                  disabled={matchAgentNumber({
                    Unassigned: () => true,
                    Loading: () => true,
                    Loaded: () => (application.agentInformation.agentNumber.key === 'Loaded' ? false : true),
                    Error: () => false,
                    UserAssignedAgentNumber: pn => (pn.length > 0 ? false : true),
                    AgentNumberError: () => false,
                  })(application.agentInformation.agentNumber)}
                  onClick={() => {
                    setBlurAgentName(true);
                    application.agentInformation.agentNumber.key === 'UserAssignedAgentNumber' &&
                      application.agentInformation.agentNumber.value.length > 0 &&
                      dispatch(getAgentName(application.agentInformation.agentNumber));
                  }}
                >
                  Get Agent Name
                </Button>
              </Grid>
            </Grid>
          </div>
        </form>
      </Grid>
    </>
  );
};

export default AgentData;
